import React, { act, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Tab from "components/Tabs/Tab";

const tabs = [
  {
    name: "Introduzione",
    videoUrl: "https://www.youtube.com/embed/hGQexxVCZeE?si=CP9csSBCNTPHA9EJ",
  },
  {
    name: "Il Comparatore",
    videoUrl: "https://www.youtube.com/embed/DRf66m1K3X0?si=cR-ynKfc-RuLj_3_",
  },
  {
    name: "L’organizer",
    videoUrl: "https://www.youtube.com/embed/Lof9hndO8jY?si=07yBzPWiPkwNHr1t",
  },
  {
    name: "La Dashboard",
    videoUrl: "https://www.youtube.com/embed/gorXPH-IWBQ?si=oeK1yTATvC2c1Fqh",
  },
  {
    name: "L’Estensione",
    videoUrl: "https://www.youtube.com/embed/hGQexxVCZeE?si=CP9csSBCNTPHA9EJ",
  },
];

const FindOutSection = () => {
  const [activeTab, setActiveTab] = useState("Introduzione");

  const tabContentVariants = {
    initial: { opacity: 0, y: 20 },
    enter: { opacity: 1, y: 0 },
  };

  return (
    <div className="py-10 lg:pb-[56px] lg:pt-[46px]">
      <div className="max-w-[1320px] mx-auto">
        <h1 className="text-[30px] lg:text-[56px] text-center font-bold text-black leading-[1.3] lg:leading-[67.77px]">
          Scopri <span className="text-primary">tutto</span> su HouseScan
        </h1>
        <div className="max-w-[1100px] mx-auto mt-[25px] md:mt-[45px] lg:mt-[79px]">
          <Tab activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />
          <AnimatePresence mode="wait">
            {tabs
              .filter((tab) => tab.name === activeTab)
              .map((tab) => (
                <motion.div
                  key={`tab-${tab.name}`}
                  className="px-5 md:px-0"
                  initial="initial"
                  animate="enter"
                  exit="exit"
                  variants={tabContentVariants}
                  transition={{ duration: 0.4 }}
                >
                  <div className="find-out-card-shadow overflow-hidden mx-auto relative w-full sm:w-[600px] lg:w-[1000px] h-[278px] md:h-[350px] lg:h-[700px] rounded-[10px] mt-[30px] lg:mt-[35px]">
                    <iframe
                      width="100%"
                      height="100%"
                      src={tab.videoUrl}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  </div>
                </motion.div>
              ))}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default FindOutSection;
